import { datetime } from "../../utils";
import I18n from "../../I18n";

const STATUS_BADGE = {
    completed: { severity: "0", family: "success" },
    error: { severity: "3", family: "destructive" },
    in_progress: { severity: "1", family: "warning" },
};

export const prepareStatusBadge = (status) =>
    STATUS_BADGE[status] ?? { severity: "1", family: "warning" };

const cell = (labels, value, type) => [{ labels, value, type }];

const parseCountryCode = (configSet) =>
    configSet ? configSet.toLowerCase().replace(/^csv_/, "") : "";

export const mapCard = ({ id, profile_name, rows_mapped, entity_name, config_set, status, started_at, completed_at }) => {
    const { severity, family } = prepareStatusBadge(status);
    const countryCode = parseCountryCode(config_set);

    return [
        cell(["ID"], id, "number"),
        cell(["Framework"], profile_name || "-", "string"),
        cell(["Rows"], rows_mapped, "number"),
        cell(["Entity"], entity_name, "string"),
        cell(["Country"], countryCode, "countryFlag"),
        cell(["Legal Structure"], "N/A", "string"), // TODO: placeholder — wire up legal structure field when available
        cell(["Status"], { label: I18n.translate(`status_${status}`), severity, family, color: "main" }, "fileStatus"),
        cell(["Created At"], datetime(started_at) ?? "-", "string"),
        cell(["Updated At"], datetime(completed_at) ?? "-", "string"),
    ];
};

const mapper = (json, card) => ({ ...json, card: card ? mapCard(json) : [] });

const header = [
    {
        label: ["ID"],
        columnName: "id",
        type: "number",
        align: "left",
        sortable: true,
    },
    {
        label: ["Framework"],
        columnName: "profile_name",
        type: "string",
        align: "left",
        sortable: true,
    },
    {
        label: ["Rows"],
        columnName: "rows_mapped",
        type: "number",
        align: "left",
        sortable: true,
    },
    {
        label: ["Entity"],
        columnName: "entity_name",
        type: "string",
        align: "left",
        sortable: true,
    },
    {
        label: ["Country"],
        columnName: "config_set",
        type: "countryFlag",
        align: "center",
        sortable: true,
    },
    {
        label: ["Legal Structure"],
        columnName: null,
        type: "string",
        align: "left",
        sortable: false,
    },
    {
        label: ["Status"],
        columnName: "status",
        type: "fileStatus",
        align: "center",
        sortable: true,
    },
    {
        label: ["Created At"],
        columnName: "started_at",
        type: "string",
        align: "left",
        sortable: true,
    },
    {
        label: ["Updated At"],
        columnName: "completed_at",
        type: "string",
        align: "left",
        sortable: true,
    },
];

const dataSyncLogMapper = { map: mapper, header };

export default dataSyncLogMapper;
